import axios from "axios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const insertAgreement = async (agreement) => {
  const res = agreement.data;
  return axios
    .post(
      `${api_base_url}/helper/insertAgreement/${res.newAgreements[0].agreementId}`
    )
    .then((res) => {
      return res;
    });
};
export const updateAgreement = async (data) => {
  const res = JSON.parse(data.config.data);
  return axios
    .post(
      `${api_base_url}/helper/UpdateAgreement/${res.newAgreements[0].agreementId}`
    )
    .then((res) => {
      return res;
    });
};
export const updateMaguireAgencyMapping = async (data) => {
  let agencyMappingId = data.config.url.replace(
    api_base_url + "/AgencyMapping/",
    ""
  );
  // console.log("AgenycMapping Result:", Number(agencyMappingId));
  return axios
    .post(
      `${api_base_url}/helper/UpdateAgencyMapping/${Number(agencyMappingId)}`
    )
    .then((res) => {
      return res;
    });
};
export const insertMaguireAgencyMapping = async (data) => {
  return axios
    .post(
      `${api_base_url}/helper/InsertAgencyMapping/${data.data.agencyMappingId}`
    )
    .then((res) => {
      return res;
    });
};
export const deleteMaguireAgencyMapping = async (ids) => {
  return axios
    .post(`${api_base_url}/helper/DeleteAgencyMapping`, ids)
    .then((res) => {
      return res;
    });
};
export const runScript = async (data) => {
  const formData = {
    script: data.script,
  };
  return axios
    .post(`${api_base_url}/helper/ExecuteQuery`, formData)
    .then((res) => {
      return res;
    });
};
export const getIsAdmin = async () => {
  return axios.post(`${api_base_url}/helper/GetIsAdmin`).then((res) => {
    return res;
  });
};
